import { NavLink, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  {
    to: '/dashboard',
    label: 'Home',
    paths: [],
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    to: '/workouts',
    label: 'Workouts',
    paths: ['/workouts'],
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6.5 6.5h11" />
        <path d="M6.5 17.5h11" />
        <path d="M4 6.5V4a1 1 0 0 1 1-1h1.5a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2.5" />
        <path d="M16.5 6.5V4a1 1 0 0 1 1-1H19a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1v-2.5" />
        <line x1="12" y1="3" x2="12" y2="21" />
      </svg>
    ),
  },
  {
    to: '/daily',
    label: 'Daily',
    paths: ['/daily', '/nutrition', '/supplements', '/daily-entry'],
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    ),
  },
  {
    to: '/wearables',
    label: 'Wearables',
    paths: ['/wearables'],
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
      </svg>
    ),
  },
  {
    to: '/social',
    label: 'Social',
    paths: ['/social', '/gyms'],
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    to: '/roast',
    label: 'Roast',
    paths: ['/roast'],
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 8h1a4 4 0 1 1 0 8h-1" />
        <path d="M3 8h14v9a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4Z" />
        <line x1="6" y1="2" x2="6" y2="4" />
        <line x1="10" y1="2" x2="10" y2="4" />
        <line x1="14" y1="2" x2="14" y2="4" />
      </svg>
    ),
  },
];

export default function MobileNav() {
  const location = useLocation();

  const isItemActive = (item) => {
    if (location.pathname === item.to) return true;
    return item.paths.some(p => location.pathname.startsWith(p));
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-30 border-t border-border backdrop-blur-xl bg-background/90">
      <div className="flex items-stretch justify-around">
        {NAV_ITEMS.map((item) => {
          const active = isItemActive(item);
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className="flex-1 no-underline"
            >
              <div className={`flex flex-col items-center justify-center gap-0.5 py-2 px-1 min-h-[56px] transition-colors duration-200 ${
                active ? 'text-primary' : 'text-foreground-muted'
              }`}>
                <div className="relative">
                  {item.icon}
                  {active && (
                    <div
                      className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full"
                      style={{ background: 'var(--accent-primary)' }}
                    />
                  )}
                </div>
                <span className="text-[10px] font-heading font-medium uppercase tracking-wide leading-tight">
                  {item.label}
                </span>
              </div>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
